require('./mortgageRequestDigitalGuide.scss');

const React = require('react');
const PropTypes = require('prop-types');

// @vendors
const { formatText, hasTranslation } = require('core/i18n').i18n;
const { connect } = require('react-redux');

// @commons
const { OKLink } = require('commonsComponents/OKLink');

// @constants
const { MORTGAGE_GUIDE } = require('constants/flagBasedFeatures');
const { DEFAULT_TRANSLATION_TEXT_MISSING_VALUE } = require('constants/translations');

// @images
const bookInformation = require("assets/icons/book-information.svg");

const MortgageRequestDigitalGuide = ({immFlagBasedFeatures}) => {

    const getPoeKey = (key) => {
        return `mortgageRequestDigitalGuide-mortgageRequestDigitalGuide_${key}`
    }

    const isMortgageGuideAvailable = immFlagBasedFeatures.get(MORTGAGE_GUIDE);

    return (
        isMortgageGuideAvailable && hasTranslation(getPoeKey('urlLinkProd')) &&
        formatText(getPoeKey('urlLinkProd')) !== DEFAULT_TRANSLATION_TEXT_MISSING_VALUE ?
            <section className="mortgage-request-digital-guide__container-box">
                <div className="row">
                    <div className="col-xs-3 mortgage-request-digital-guide__icon-section">
                        <img
                            src={bookInformation}
                        ></img>
                    </div>
                    <div className="col-xs-9 mortgage-request-digital-guide__content-section">
                        <h4>{formatText(getPoeKey('titlePanel'))}</h4>
                        <p>{formatText(getPoeKey('descriptionPanel'))}</p>
                        <OKLink
                            icon="pdf"
                            iconLarge
                            modifier="editorial"
                            size="small"
                            target="_blank"
                            to={formatText(getPoeKey('urlLinkProd'))}
                        >
                            {formatText(getPoeKey('labelLink'))}
                        </OKLink>
                    </div>
                </div>
            </section>
        : null
    )
}

MortgageRequestDigitalGuide.propTypes = {
    immFlagBasedFeatures: PropTypes.object
};

module.exports.MortgageRequestDigitalGuide = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures
    }),null
)(MortgageRequestDigitalGuide);